export default __webpack_public_path__ + "static/media/cù.84fa4e76.mp3";